var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-progress",style:({backgroundColor:_vm.trackColor,width:_vm.strokeWidth,height:_vm.strokeHeight})},[_c('div',{staticClass:"m-progress-bar",style:({backgroundColor:_vm.color,left:((_vm.percentage/2).toFixed(0))+'%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }